// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"b36f8bc6","61":"9e8e8f71","116":"970f1299","231":"6400c4b4","343":"9785190b","423":"ca4ac609","473":"d1cfd00f","521":"a0a93f0d","572":"4cb64a59","636":"2334a512","680":"2df3d534","787":"c348d4b7","853":"4f67e7b8","858":"bb46e1d8","940":"6e85be3d","941":"aeefb84f"}[chunkId] + ".js";
};